import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostEventMove = (levelRef, minuteRef, secRef) => {
	const [fetchResult, fetchRequest] = useFetch()
	const {idx} = useParams()
	const [, setAlert] = useAlertModalAtom()

	const request = () => {
		let levelValue = levelRef?.current?.value
		if (!levelValue) {
			setAlert('레벨을 확인해 주세요.')
			return
		}
		let url = `/admin/event/${idx}/move`

		fetchRequest('POST', url, {
			level: levelValue,
			minute: minuteRef?.current?.value,
			second: secRef?.current?.value,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx를 확인해 주세요.')
				else if (['level', 'time'].includes(fetchResult?.data?.error_code))
					setAlert('레벨 또는 시간을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePostEventMove
